import styled from 'styled-components';

export const ErrorMessage = styled.div`
    color: ${props => props.theme.colors.red};
    font-size: ${props => props.theme.fontSize.sm || '12px'};
    padding: 4px 0;
    width: 100%;
`;

